<template>
  <router-view/>
</template>

<script>
export default {
  name: 'FunnelReport'
}
</script>

<style>

</style>
